import { v4 as uuidv4 } from 'uuid';
import { ComponentType, type IComponentSchema } from '../../types';
import { JsonFieldType } from '../../../types';
import type { IFiltersProps } from '.';

export const generate = (
  props?: Partial<IComponentSchema<IFiltersProps>>
): IComponentSchema<IFiltersProps> => {
  const id = uuidv4();

  return {
    type: JsonFieldType.VOID,
    name: props?.name || id,
    title: props?.title || 'Filters',
    'x-designable-id': id,
    'x-index': props?.['x-index'] || 0,
    'x-component': ComponentType.Filters,
    'x-component-props': {
      filters: {},
      search: {
        enabled: true,
        searchableFields: [],
      },
    },
    'x-component-props-config': {},
  };
};
